<template>
  <TopBanner />
  <div class="relative">
    <SideMenu />
    <slot />
    <SiteFooter />
  </div>
</template>
